import { Accordion, Paper, Stack, Text, Title } from "@mantine/core";
import type { LegacyReviewData } from "../../../types/legacyCases";
import {
  formatLegacyDate,
  LEGACY_NARRATIVES,
} from "../../../utils/legacyReviewForm";

export default function LegacyReviewedNarratives({
  review,
}: {
  review: LegacyReviewData;
}) {
  return (
    <Paper withBorder p="md">
      <Stack gap="lg">
        <Title order={3}>Reviewed historical report</Title>
        <Text size="sm">
          Received: {formatLegacyDate(review.dateReceived)} · Collected:{" "}
          {formatLegacyDate(review.dateCollected)} · Reported:{" "}
          {formatLegacyDate(review.reportedDate)}
        </Text>
        {LEGACY_NARRATIVES.map(({ field, label }) =>
          review[field] ? (
            <Stack gap="xs" key={field}>
              <Title order={4}>{label}</Title>
              <Text
                size="sm"
                style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
              >
                {review[field]}
              </Text>
            </Stack>
          ) : null
        )}
        {(review.additionalSections ?? []).map((section, index) => (
          <Accordion key={`${section.kind}-${index}`} variant="contained">
            <Accordion.Item value="text">
              <Accordion.Control>{section.label}</Accordion.Control>
              <Accordion.Panel>
                <Text
                  size="sm"
                  style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
                >
                  {section.text}
                </Text>
              </Accordion.Panel>
            </Accordion.Item>
          </Accordion>
        ))}
        {(review.specimens ?? []).map((specimen, index) => (
          <Stack key={index} gap="xs">
            <Title order={4}>Specimen {specimen.number}</Title>
            <Text size="sm" style={{ whiteSpace: "pre-wrap" }}>
              {specimen.evidenceText}
            </Text>
            {specimen.completedSlides?.map((slide, slideIndex) => (
              <Text
                key={slideIndex}
                size="sm"
                style={{ whiteSpace: "pre-wrap" }}
              >
                Completed slide {slide.number}: {slide.evidenceText}
              </Text>
            ))}
          </Stack>
        ))}
      </Stack>
    </Paper>
  );
}
